<style>
.confirmation_header {
    font-weight: 500;
    font-size: 18px;
    line-height: 17px;
    text-align: center;
    color: #404455;
    padding-bottom: 33px;
}
.button_group {
    display: flex;
    align-items: center;
    justify-content: center;
}
.button_group button {
    margin-left: 10px;
    margin-right: 10px;
    width: 135px;
    height: 48px;
    background: #FF0000!important;
    border: 1px solid #FF0000;
    box-sizing: border-box;
    border-radius: 5px;
    color: #FFFFFF!important;
    font-weight: bold;
    cursor: pointer;
    transition: 0.25s;
    line-height: 0.9;
}
.button_group button:hover {
    background-color: #DD0000!important;
    color: #FFFFFF;
}
.button_group button:active, .button_group button:focus {
    background-color: #FF0000!important;;
    color: #FFFFFF!important;
    box-shadow: 0 0 0 0.2rem #FF000060;
}
.button_group button:nth-child(1) {
    background: #FFFFFF!important;
    border: 1px solid #FF0000;
    color: #FF0000!important;
}
.button_group button:nth-child(1):hover {
    background-color: #FF0000!important;
    color: #FFFFFF!important;
}
.button_group button:nth-child(1):active, .button_group button:nth-child(1):focus {
    background-color: #FF0000!important;;
    color: #FFFFFF!important;
    box-shadow: 0 0 0 0.2rem #FF000060;
}
</style>

<script >
import { mutations, modalState, combinedArray, modalTitle, tabImagesArray} from '../mainStore.js';

function yes() {
    let state = {...$modalState}
    mutations.setShowModal(state.showModal)
    mutations.setModalTitle(state.modalTitle)
    mutations.setModalType(state.modalType)
    mutations.setModalState(state.modalState)
}
</script>

<div>
    <div class="confirmation_header">Нет места</div>
    <div class="button_group">
        <button on:click={yes}>Ок</button>
    </div>
</div>
